import React, {PropsWithChildren} from "react"
import {Box} from "@mui/material"
import frills from "../../icon/frills.svg"
import {ReactComponent as Shadow} from "../../icon/shadow.svg"

interface BobbingIconProps {
  horizontalOffset?: string
  verticalOffset?: string
}

function BobbingIcon({
                       horizontalOffset,
                       verticalOffset,
                       children,
                     }: PropsWithChildren<BobbingIconProps>) {
  return (
    <Box
      sx={{
        position: "relative",
        maxWidth: 418,
        maxHeight: 293,
        mx: "auto",
        pb: "40px",
      }}
    >
      <Box component="img" src={frills} alt="" sx={{width: "100%"}}/>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "48%",
          ml: horizontalOffset ?? "0px",
          mt: verticalOffset ?? "0px",
          animation: "bob 1.7s ease-in-out infinite",
          "@keyframes bob": {
            "0%": {transform: "translateY(0px)"},
            "50%": {transform: "translateY(-10px)"},
            "100%": {transform: "translateY(0px)"},
          },
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          ml: "-35px",
          animation: "enlarge 1.7s ease-in-out infinite",
          "@keyframes enlarge": {
            "0%": {transform: "scale(1)", opacity: 1},
            "50%": {transform: "scale(1.4)", opacity: 0.7},
            "100%": {transform: "scale(1)", opacity: 1},
          },
        }}
      >
        <Shadow/>
      </Box>
    </Box>
  )
}

export default BobbingIcon
